import React from "react";
import { Button } from "@petsapp/chameleon";
import { FormType } from "./auth-controller";
import { useTranslation } from "../../utils/i18n";

interface ResetPasswordFormProps {
  setFormType: React.Dispatch<React.SetStateAction<FormType>>;
}

export const ResetSuccessful: React.FunctionComponent<ResetPasswordFormProps> = ({
  setFormType,
}) => {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      variant="primary"
      onClick={() => setFormType("login")}
    >
      {t("Okay")}
    </Button>
  );
};
